import { useQuery } from "@tanstack/react-query";

import { crefazCltService } from "../services/crefazCltService";

const STALE_TIME = 1000 * 60 * 60;

export const useCrefazCltCities = (uf?: string, nomeCidade?: string) => {
  const search = nomeCidade?.trim() ?? "";
  const enabled = Boolean(uf && search.length >= 3);

  const { data, isFetching } = useQuery({
    queryKey: ["crefaz-clt-cities", uf, search.toLowerCase()],
    queryFn: () => crefazCltService.getCities({ uf: uf!, nomeCidade: search }),
    select: (response) => response.data,
    staleTime: STALE_TIME,
    enabled,
  });

  return { cities: data ?? [], isFetching, enabled };
};
